import { Link } from 'react-router-dom'
import { FAIR_USE_POLICY_PATH, PRIVACY_POLICY_PATH, SUBSCRIPTION_TERMS_PATH } from '../../config/legal'

interface SubscriptionConsentCheckboxProps {
  checked: boolean
  onChange: (checked: boolean) => void
  id?: string
}

/**
 * Required before Learn Library Stripe checkout. Must not be pre-checked.
 */
export default function SubscriptionConsentCheckbox({
  checked,
  onChange,
  id = 'digital-content-consent',
}: SubscriptionConsentCheckboxProps) {
  return (
    <div className="rounded-lg border border-navy-600 bg-navy-900/50 p-4 text-left">
      <label htmlFor={id} className="flex cursor-pointer gap-3 text-sm text-gray-200 leading-relaxed">
        <input
          id={id}
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          required
          aria-required="true"
          className="mt-1 h-4 w-4 shrink-0 rounded border-navy-500 text-gold-500 focus:ring-gold-500"
        />
        <span>
          I request immediate access to the digital content and understand that by doing so I waive my 14-day right to
          cancel under the Consumer Contracts Regulations 2013, once access is granted. I have read and agree to the{' '}
          <Link
            to={SUBSCRIPTION_TERMS_PATH}
            target="_blank"
            rel="noopener noreferrer"
            className="text-gold-400 underline hover:text-gold-300"
          >
            Subscription Terms
          </Link>
          ,{' '}
          <Link
            to={FAIR_USE_POLICY_PATH}
            target="_blank"
            rel="noopener noreferrer"
            className="text-gold-400 underline hover:text-gold-300"
          >
            Fair Use &amp; Access Policy
          </Link>{' '}
          and{' '}
          <Link
            to={PRIVACY_POLICY_PATH}
            target="_blank"
            rel="noopener noreferrer"
            className="text-gold-400 underline hover:text-gold-300"
          >
            Privacy Policy
          </Link>
          .
        </span>
      </label>
    </div>
  )
}
